export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "ChapterUtil.functional.worker.js?26efb29b77047671292d");
}
